import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../context';
import { ROUTES } from '../constants';

interface PublicRouteProps {
  restricted?: boolean;
}

export function PublicRoute({ restricted = false }: PublicRouteProps) {
  const { isAuthenticated } = useAuth();

  // If restricted and user is authenticated, redirect to home
  if (restricted && isAuthenticated) {
    return <Navigate to={ROUTES.HOME} replace />;
  }

  return <Outlet />;
}
